import Vue from 'vue';
import VueTheMask, { VueMaskDirective } from 'vue-the-mask';

Vue.use(VueTheMask);
Vue.directive('mask', VueMaskDirective);
Vue.directive('conditional-mask', {
  bind(el, binding) {
    const { value } = binding;

    if (value && value.mask) {
      el.setAttribute('v-mask', value.mask);
    }
  },
});